import { render, staticRenderFns } from "./UtilPlaceholder.vue?vue&type=template&id=5bbfd3ab&scoped=true"
import script from "./UtilPlaceholder.vue?vue&type=script&lang=js"
export * from "./UtilPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./UtilPlaceholder.vue?vue&type=style&index=0&id=5bbfd3ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbfd3ab",
  null
  
)

export default component.exports